module.exports = __webpack_public_path__ + "img/messenger.2d1a7db2.svg";